import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';

import { connect } from 'react-redux';
import config from 'cfg';
import styled, { keyframes } from 'styled-components';
import classNames from 'classnames';

const ANIMATION_LENGTH = 0.25;
const SLIDE_WIDTH = 240;

import CopyIcon from 'material-ui/svg-icons/content/content-copy';
// const SLIDE_SCALE = SLIDE_WIDTH / SLIDE_POPUP_WIDTH;

const roundAnim = keyframes`
  0% {
    
    transform: rotate(0deg);
  }
  100% {
   
    transform: rotate(360deg);
  }
`;

const load6Anim = keyframes`
  0% {
    box-shadow: 0 -0.83em 0 -0.4em, 0 -0.83em 0 -0.42em, 0 -0.83em 0 -0.44em, 0 -0.83em 0 -0.46em, 0 -0.83em 0 -0.477em;
  }
  5%,
  95% {
    box-shadow: 0 -0.83em 0 -0.4em, 0 -0.83em 0 -0.42em, 0 -0.83em 0 -0.44em, 0 -0.83em 0 -0.46em, 0 -0.83em 0 -0.477em;
  }
  10%,
  59% {
    box-shadow: 0 -0.83em 0 -0.4em, -0.087em -0.825em 0 -0.42em, -0.173em -0.812em 0 -0.44em, -0.256em -0.789em 0 -0.46em, -0.297em -0.775em 0 -0.477em;
  }
  20% {
    box-shadow: 0 -0.83em 0 -0.4em, -0.338em -0.758em 0 -0.42em, -0.555em -0.617em 0 -0.44em, -0.671em -0.488em 0 -0.46em, -0.749em -0.34em 0 -0.477em;
  }
  38% {
    box-shadow: 0 -0.83em 0 -0.4em, -0.377em -0.74em 0 -0.42em, -0.645em -0.522em 0 -0.44em, -0.775em -0.297em 0 -0.46em, -0.82em -0.09em 0 -0.477em;
  }
  100% {
    box-shadow: 0 -0.83em 0 -0.4em, 0 -0.83em 0 -0.42em, 0 -0.83em 0 -0.44em, 0 -0.83em 0 -0.46em, 0 -0.83em 0 -0.477em;
  }
`;

class NetflixGallery extends React.Component {
    constructor(props) {
        super(props);

        this.onEnterSafe = _.throttle(this.onEnter, 100);
        this.onLeaveSafe = _.throttle(this.onLeave, 100);
        this._blocked = false;
        this._lastZoomedIndex = -1;
    }

    slides = [];

    componentDidMount = () => {
        this._autofixIntervalId = setInterval(() => {
            if (!this._blocked && this._lastZoomedIndex != -1 && this._lastZoomedIndex !== this.state.zoomedIndex) {
                // do zoom
                this.setState({
                    zoomedItem: this.props.list[this._lastZoomedIndex],
                    zoomedIndex: this._lastZoomedIndex,
                });
            }
        }, 500);
        this._debounceHandleScreenSizeUpdate = _.debounce(() => {
            this.forceUpdate();
        }, 100);
        window.addEventListener('resize', this._debounceHandleScreenSizeUpdate, false);
    };

    componentWillUnmount = () => {
        if (this._autofixIntervalId) clearInterval(this._autofixIntervalId);
        window.removeEventListener('resize', this._debounceHandleScreenSizeUpdate, false);
    };

    onEnter = (item, i) => {
        // this._lastZoomedIndex = i;
        if (this.state.zoomedIndex === i) return;
        if (this._blocked) {
            return;
        }
        this._blocked = true;
        this.setState({ zoomedItem: item, zoomedIndex: i });

        clearTimeout(this._blockedINT);
        this._blockedINT = setTimeout(() => {
            this._blocked = false;
        }, ANIMATION_LENGTH * 1000);
    };

    onLeave = () => {
        this.setState({ zoomedItem: null, zoomedIndex: -1 });
        this._lastZoomedIndex = -1;
    };

    state = {
        zoomedItem: null,
        zoomedIndex: -1,
    };

    static defaultProps = {
        list: [],
        zoomFactor: 1.5,
    };

    render() {
        const { zoomFactor } = this.props;
        const { zoomedIndex, selectedItem } = this.state;

        const activeSlide = this.slides[zoomedIndex] || {};

        // &:first-child {
        //     transform: ${props => props.doShift && props.firstIsZoomed && `translate3d(${SLIDE_SHIFT}px, 0, 0)`};
        // }

        const cw = _.get(this, 'container.offsetWidth', 200);
        // const sw = (this.slides || []).reduce((sum, s) => sum + s.offsetWidth + 4, 0);
        // const rzw = _.get(this, 'rowZoomable.offsetWidth', 0);

        let total = 0;
        let curentRow = -1;

        (this.slides || []).forEach((slide, i) => {
            // const startPX = curentRow * cw;
            // const endPX = (curentRow + 1) * cw;

            const testTotal = total + slide.offsetWidth;

            slide.row = Math.floor(testTotal / cw);

            slide.firstInRow = false;
            slide.lastInRow = false;
            if (slide.row !== curentRow) {
                slide.firstInRow = true;

                curentRow = slide.row;
                total = curentRow * cw;
                if (i > 0) this.slides[i - 1].lastInRow = true; // set last in a row
            }
            if (this.slides.length === i + 1) this.slides[i].lastInRow = true;
            total += slide.offsetWidth;
        });

        return (
            <div
                ref={r => (this.container = r)}
                className="netflix"
                style={{
                    zIndex: zoomedIndex !== -1 ? 1000 : 0,
                }}
            >
                <div>
                    {this.props.list.map((item, i) => {
                        const activeRow = this.slides[i] && activeSlide && activeSlide.row === this.slides[i].row;
                        const firstInRow = this.slides[i] && this.slides[i].firstInRow;
                        const lastInRow = this.slides[i] && this.slides[i].lastInRow;
                        const movedActiveStyles = {
                            zIndex: 10004,
                        };
                        const halfZoom = (zoomFactor - 1.0) / 2;
                        if (firstInRow) {
                            movedActiveStyles.transform = `translate3d(${activeSlide.offsetWidth * halfZoom ||
                                0}px, 0, 0)`;
                            movedActiveStyles.marginLeft = -2;
                        } else if (lastInRow) {
                            movedActiveStyles.transform = `translate3d(-${activeSlide.offsetWidth * halfZoom ||
                                0}px, 0, 0)`;
                        }

                        const movedLeftStyles = {
                            transform: `translate3d(${-activeSlide.offsetWidth *
                                halfZoom *
                                (activeSlide.lastInRow ? 2 : 1) || 0}px, 0, 0)`,
                        };

                        const movedRightStyles = {
                            transform: `translate3d(${activeSlide.offsetWidth *
                                halfZoom *
                                (activeSlide.firstInRow ? 2 : 1) || 0}px, 0, 0)`,
                        };

                        return (
                            <div
                                ref={r => {
                                    this.slides[i] = r;
                                }}
                                key={this.props.renderKey(item, { zoomed: zoomedIndex === i })}
                                className={`netflix-slide ${zoomedIndex === i && 'netflix-slide-active'}`}
                                style={{
                                    display: 'inline-block',
                                    position: 'relative',
                                    transition: `all ${ANIMATION_LENGTH}s linear`,
                                    zIndex: 100,
                                    ...(i == zoomedIndex ? movedActiveStyles : {}),
                                    ...(activeRow && i < zoomedIndex ? movedLeftStyles : {}),
                                    ...(activeRow && i > zoomedIndex ? movedRightStyles : {}),
                                }}
                                onMouseEnter={this.onEnterSafe.bind(this, item, i)}
                                onMouseMove={() => {
                                    this._lastZoomedIndex = i;
                                }}
                                onMouseLeave={this.onLeaveSafe}
                                onClick={() => {
                                    this.setState({ zoomedItem: null, zoomedIndex: -1 });
                                    const elem = ReactDOM.findDOMNode(this.refs.container);
                                    if (elem) {
                                        window.scrollTo({
                                            top: elem.offsetTop,
                                            behavior: 'smooth',
                                        });
                                    }
                                }}
                            >
                                {this.props.renderItem(item, {
                                    zoomFactor,
                                    zoomed: !selectedItem && zoomedIndex === i,
                                })}
                            </div>
                        );
                    })}
                </div>
                <div style={{ height: 50 }} />
                {/* {selectedItem ? (
                    <div>
                        <FlatButton
                            label="close"
                            onClick={() => {
                                this.setState({ selectedItem: null });
                                window.scrollTo({
                                    top: elem.offsetTop,
                                    behavior: 'smooth',
                                });
                            }}
                        />
                        <h1>FULL VIEW</h1>
                        {this.props.renderFullView(selectedItem)}
                    </div>
                ) : null} */}
            </div>
        );
    }
}

const WidgetPreviewUI = styled.div`
    position: relative;
    cursor: pointer;

    display: inline-block;
    width: auto;
    min-width: 150px;
    margin: 2px;
    z-index: 50;

    ${props =>
        props.allowZoom &&
        `&:hover {
        z-index: 1000;
             
    }`} .regular-slide {
        overflow: hidden;
        position: relative;
        min-height: 100px;
        transition: all ${ANIMATION_LENGTH}s linear;
    }

    &.gallery-item-zoomed {
        .regular-slide {
            transform: scale(${props => props.zoomFactor || 1.7});
        }
    }
    .w-thumb-image {
        position: relative;
        height: 100%;
        max-height: ${SLIDE_WIDTH};
        object-fit: cover;
        object-position: top;
        z-index: 99;
    }

    .w-container {
        position: relative;
        background: #000;
        text-align: center;
    }
    .w-container-init {
        opacity: 0;
    }
    .w-name {
        position: relative;
        padding: 0 8px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: #fff;
        background: #222;

        font-size: 14px;
        line-height: 26px;
    }

    .badges-bar {
        position: absolute;
        bottom: 2px;
        padding: 2px 5px;
        z-index: 1000;
        right: 2px;
        font-size: 14px;
        opacity: 0.8;
        background: rgba(0, 0, 0, 0.8);
        display: flex;
        align-items: center;
        span {
            padding-left: 4px;
        }
    }

    .demo-badge {
        position: absolute;
        top: 12px;
        right: -23px;
        background: red;
        z-index: 1001;
        padding: 3px 25px;
        color: #fff;
        transform: rotate(45deg);
    }
    &:hover {
        .video-badge {
            zoom: 1.2;
            opacity: 0.9;
        }
    }
    .video-badge {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 50px;
        height: 50px;
        border-radius: 50%;
        background: #fff;
        box-shadow: 0 0 5px #000;
        z-index: 10000;
        opacity: 0.8;

        &:after {
            position: absolute;
            content: '';
            box-sizing: border-box;

            width: 22px;
            height: 22px;
            z-index: 100005;
            top: 50%;
            left: 50%;
            transform: translate(-40%, -50%);
            border-width: 11px 0px 11px 22px;
            border-style: solid;
            border-color: transparent transparent transparent #202020;
        }
    }
    &.gallery-item-loading {
        .w-thumb-image {
            opacity: 0.7;
        }
    }
    &.gallery-item-loaded {
    }
    &.gallery-item-errored {
        .w-thumb-image {
            visibility: hidden;
        }
    }
    .errored {
        color: #ffffff;
        font-size: 45px;
        overflow: hidden;
        width: 50px;
        height: 50px;
        border-radius: 50%;
        margin-left: -25px;
        margin-top: -25px;
        position: absolute;
        z-index: 1001;
        transform: translateZ(0);
        left: 50%;
        top: 50%;
        background: red;
    }
    .loading {
        color: #ffffff;
        font-size: 45px;
        text-indent: -9999em;
        overflow: hidden;
        width: 50px;
        height: 50px;
        border-radius: 50%;
        margin-left: -25px;
        margin-top: -25px;
        position: absolute;
        z-index: 1001;
        transform: translateZ(0);
        left: 50%;
        top: 50%;
        animation: ${load6Anim} 1.7s infinite ease, ${roundAnim} 1.7s infinite ease;
    }
`;

const WidgetPreviewUIHorizontal = WidgetPreviewUI.extend`
    width: ${SLIDE_WIDTH};
    height: auto;
    min-height: 150px;
    max-height: none;
    .w-thumb-image {
        width: 100%;
        max-height: none;
        height: auto;
    }
    &.gallery-item-errored {
        max-height: 150px;
        background: #000;
        img {
            display: none;
        }
    }
`;

class WidgetPreviewComponent extends React.Component {
    state = {
        anim: 'init',
        expanded: false,
        imageState: 'loading',
        retry: 0,
    };

    componentWillReceiveProps = nextProps => {
        const canBeZoomed = this.state.imageState !== 'errored';

        if (canBeZoomed && nextProps.zoomed && nextProps.zoomed !== this.props.zoomed) {
            this.setState({ anim: 'zoomed' });
        }
        if (canBeZoomed && !nextProps.zoomed && nextProps.zoomed !== this.props.zoomed) {
            this.setState({ anim: 'idle', expanded: false });
        }

        if (nextProps.props && nextProps.props.template !== this.props.props.template) {
            this.setState({ imageState: 'loading' });
        }
    };

    onStartLoad = e => {
        console.log('ON,', e.target);
    };

    onLoaded = () => {
        this.setState({ imageState: 'loaded' });
    };

    onErrorLoad = () => {
        this.setState({ imageState: 'errored' });
    };

    static defaultProps = {
        demo: false,
        usePreview: false,
        wdpcache: 'state',
        orientation: 'height',
        allowZoom: false,
        zoomFactor: 1.7,
    };

    render = () => {
        const {
            user,
            widgetId,
            widget,
            name,
            onClick,
            props,
            demo,
            wdpcache,
            allowZoom,
            template,
            style = {},
            zoomFactor,
        } = this.props;

        const { anim, imageState, retry } = this.state;

        //
        //
        let lang = user.defaultProps.find(({ key }) => key === 'lang');

        lang = (lang && lang.value) || 'da';

        let widgetURL = config.WDPLinkr.widget.image(user.client, user.username, 'default', widgetId, {
            lang,
            ...props,
            wdpcache,
        });
        // combine demo url

        if (demo) {
            widgetURL =
                (widget && widget.demoURL) ||
                config.WDPLinkr.widget.demo(user.client, user.username, 'default', widgetId, {
                    lang,
                    template,
                    i: 'gallery2',
                });
        }

        if (retry !== 0) {
            widgetURL = config.WDPLinkr.widget.demo(user.client, user.username, 'default', widgetId, {
                lang,
                template,
                i: 'gallery2',
                forceUpdate: true,
            });
        }

        const CMP = this.props.orientation == 'height' ? WidgetPreviewUI : WidgetPreviewUIHorizontal;

        return (
            <CMP
                zoomFactor={zoomFactor}
                onDragStart={dragStart(widgetId, {
                    ...props,
                    client: user.client,
                    username: user.username,
                })}
                className={classNames(
                    {
                        'gallery-items-stack': widget && widget.layouts > 1,
                    },
                    `gallery-item-${imageState}`,
                    `gallery-item gallery-item-${anim}`,
                )}
                orientation={this.props.orientation}
                onClick={onClick}
                allowZoom={imageState == 'loaded' && allowZoom}
                style={style}
            >
                {/* <span className="loading" /> */}
                {imageState === 'loading' && <span className="loading" />}
                {imageState === 'errored' && (
                    <span
                        className="errored"
                        onClick={e => {
                            e.stopPropagation();
                            console.log('EI');
                            this.setState({
                                imageState: 'loading',
                                retry: Math.random(),
                            });
                        }}
                    >
                        Retry
                    </span>
                )}

                <div className="regular-slide">
                    {_.get(widget, 'spec.video', false) && <span className="video-badge"> </span>}
                    {demo && (
                        <span
                            className="demo-badge"
                            onClick={e => {
                                e.stopPropagation();

                                this.setState({
                                    imageState: 'loading',
                                    retry: Math.random(),
                                });
                            }}
                        >
                            DEMO
                        </span>
                    )}
                    <div className="w-container">
                        <img
                            key={widgetURL + '_' + this.props.template}
                            className="w-thumb-image"
                            src={widgetURL}
                            onLoadStart={this.onStartLoad}
                            onLoad={this.onLoaded}
                            onError={this.onErrorLoad}
                        />
                        {widget &&
                            widget.layouts > 1 && (
                                <div className="badges-bar">
                                    <CopyIcon style={{ width: 18, height: 18 }} />
                                    <span>x{widget.layouts}</span>
                                </div>
                            )}
                    </div>

                    <div className="w-name">{name || (widget && widget.name) || widgetId}</div>
                </div>
            </CMP>
        );
    };
}

const dragStart = (widgetId, props) => event => {
    console.log('on ---- ', widgetId, props);

    if (!props.template) {
        alert('cant be dragged');
    }

    event.dataTransfer.setData(
        'rule',
        JSON.stringify({
            campaignId: '5bee9679a9ae562380ed91fb',
            presentation: {
                name: widgetId,
                params: {
                    ...props,
                },
                type: 'widget-social',
            },
            triggerType: 'time',
            messageTemplateIds: [],
            signature: null,
            message: null,
            conditions: [],
            patterns: [],
        }),
    );
};

const WidgetPreview = connect(({ user }) => ({ user }))(WidgetPreviewComponent);

const WidgetPreviewStatic = connect(({ user }) => ({ user, zoom: false, orientation: 'width' }))(
    WidgetPreviewComponent,
);

export { WidgetPreview, WidgetPreviewStatic };
export default NetflixGallery;



/** WEBPACK FOOTER **
 ** ../src/dash/front/editor/components/NetflixGallery.js
 **/